export default {
	"menu": {
		// base
		"home": "首页",
		"projectDetail": "项目详情",
	},
	"components": {
		"treeTable": {
			"emptyText": "暂无数据"
		}
	},
	"enum": {
		"assessStatus": {
			"wait": "待评价",
			"complete": "已评价"
		},
		"sex": {
			"Male": "男",
			"Female": "女"
		},
		"sOrF": {
			"Success": "成功",
			"Failure": "失败"
		},
		"resourceType": {
			"root": "根目录",
			"directory": "目录",
			"menu": "菜单",
			"action": "功能",
			"tab": "页签",
			"group": "分组"
		},
		"sortType": {
			"former": "原位置",
			'top': "置顶",
			'bottom': "置底",
			'upDown': "上移或下移"
		},
		typeList: {
			"development": "开发版",
			"internalTest": "内测版",
			"publicTest": "公测版",
			"experience": "体验版",
			"formal": "正式版"
		},
		yesOrNo: {
			"Yes": "是",
			"No": "否"
        },
        actStatus: {
            "null": " ",
            "before": "未开始",
            "on": "进行中",
            "after": "已结束"
        },
		pubState: {
			'published': '已发布',
			'unpublished': '未发布'
		},
		authTypeList: {
			"experience": "体验",
			"charge": "购买"
		},
		innerOrOuter: {
			'inner': "内部",
			'outer': "外部"
		},
		flowState: {
			"unStart": "待发起",
			// "start": "已发起",
			"running": "审批中",
			"end": "已审批",
			// "revoke": "已撤销",
		},
		approvalType: {
			"pending": "待审批",
			"approved": "已审批",
		},
		approvalAction: {
			'pass': "通过",
			'veto': "否决",
			'back': "打回",
		},
	},
	"entity": {
		// base
		"tenant": {
			"charge": "负责人",
			"authStartTime": "授权开始时间",
			"authEndTime": "授权结束时间",
			"authTime": "授权起止时间",
			"authNum": "授权用户数",
			"email": "联系人邮箱",
			"code": "租户代码",
			"name": "租户名称",
			"ver": "版本号",
			"website": "官网",
			"sysName": "系统名称",
			"credCode": "租户信用代码",
			"id": "租户ID",
			"mobile": "联系人电话",
			"remark": "备注",
			"updateTime": "更新时间",
			"enabled": "启用",
			"state": "数据状态",
			"createTime": "创建时间",
			"shortName": "租户简称",
			"copyRight": "租户版权号",
			"createUserId": "创建人ID",
			"updateUserId": "更新人ID"
		},
		"cfg": {
			"wx": "微信配置",
			"mail": "企业邮箱配置",
			"id": "ID",
			"updateTime": "更新时间",
			"host": "主机",
			"port": "端口号",
			"encode": "格式",
			"username": "用户名",
			"password": "密码"
		},
		"product": {
			"id": "产品ID",
			"logoFileId": "logo编号",
			"remark": "备注",
			"name": "产品名称",
			"ver": "版本号",
			"updateTime": "更新时间",
			"updateUserId": "更新人ID",
			"createTime": "创建时间",
			"sortNum": "授权用户数",
			"enabled": "启用/禁用",
			"code": "产品代码",
			"type": "产品类型",
			"state": "数据状态",
			"tags": "标签",
			"createUserId": "创建人ID"
		},
	},
	"tips": {
		"add": {
			"success": "添加成功",
		},
		"save": {
			"success": "保存成功",
			"error": "数据没有发生变化,请确认后重新操作"
		},
		"update": {
			"success": "修改成功"
		},
		"delete": {
			"success": "删除成功"
		},
		"landInvest": {
			"save": {
				"success": "土地保存成功"
			}
		},
		"decision": {
			"success": "决策评估成功"
		}
	}
}